module.exports = __webpack_public_path__ + "static/media/open_door.43accd18.png";